function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M22 6l-5 2V6c0-1.1-.9-2-2-2H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-2l5 2c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default SvgComponent;